/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Features_Title_LeadInputs */

const en_portal_features_title_lead = /** @type {(inputs: Portal_Features_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everything you train with,`)
};

const pl_portal_features_title_lead = /** @type {(inputs: Portal_Features_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszystko, z czym trenujesz,`)
};

/**
* | output |
* | --- |
* | "Everything you train with," |
*
* @param {Portal_Features_Title_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_features_title_lead = /** @type {((inputs?: Portal_Features_Title_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Features_Title_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_features_title_lead(inputs)
	return en_portal_features_title_lead(inputs)
});